// extracted by mini-css-extract-plugin
module.exports = {"image":"login_image__tlZdm","imageArea":"login_imageArea__2BEqV","panel":"login_panel__3pYEv"};